import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a date value from D1/SQLite to a localized date string.
 * Handles SQLite datetime format ("YYYY-MM-DD HH:MM:SS") and ISO format.
 */
export function formatDate(dateValue: string | null | undefined): string {
  if (!dateValue) return "N/A";

  let parsed: Date;

  // Handle SQLite datetime format: "2025-01-28 07:00:00"
  if (dateValue.includes(" ") && !dateValue.includes("T")) {
    parsed = new Date(dateValue.replace(" ", "T") + "Z");
  } else {
    parsed = new Date(dateValue);
  }

  if (isNaN(parsed.getTime())) return "Invalid Date";
  return parsed.toLocaleDateString();
}

/**
 * Format a date value to a localized datetime string (date + time).
 */
export function formatDateTime(dateValue: string | null | undefined): string {
  if (!dateValue) return "N/A";

  let parsed: Date;

  if (dateValue.includes(" ") && !dateValue.includes("T")) {
    parsed = new Date(dateValue.replace(" ", "T") + "Z");
  } else {
    parsed = new Date(dateValue);
  }

  if (isNaN(parsed.getTime())) return "Invalid Date";
  return parsed.toLocaleString();
}

